import t from 'react-translate';
import { useContext } from 'react';
import { css } from '@emotion/react';
import { useSelector } from 'react-redux';
import { almostWhite } from 'athena/styles/colors';
import MentoringProgramContext from '../../context';
import MaxMenteesSetting from './max-mentees-setting';
import MentorCapacitySetting from './mentor-capacity-setting';
import { headerLineHeight } from 'styles/global_defaults/fonts';
import { quarterSpacing } from 'styles/global_defaults/scaffolding';
import { getMentoringProgramAliases } from 'redux/selectors/mentoring-programs';

const subtitleStyles = css`
  line-height: ${headerLineHeight}px !important;
`;
const styles = css`
  background-color: ${almostWhite};
  border-radius: ${quarterSpacing}px;
`;

const ProgramConnections = ({ onSubmit }) => {
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const mentoringProgramAliases = useSelector((state) =>
    getMentoringProgramAliases(state, mentoringProgram.id)
  );

  return (
    <div className='mb-4'>
      <div className='heading-5 mb-2'>
        {t.MENTORING_PROGRAMS.CONNECTIONS.TITLE()}
      </div>
      <div className='text-black mb-2 text-regular' css={subtitleStyles}>
        {t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_SETUP.CONNECTIONS.SUBTITLE(
          mentoringProgramAliases
        )}
      </div>
      <div className='pl-4 pr-4 pt-2 pb-2' css={styles}>
        <MaxMenteesSetting name='maxMentees' onSubmit={onSubmit} />
        <MentorCapacitySetting
          name='mentorCapacityEnabled'
          onSubmit={onSubmit}
        />
      </div>
    </div>
  );
};

export default ProgramConnections;
